import { applyWatchlistContextRefreshRevision } from './ApiCall';
import { normalizeWatchlistLifecycle } from './watchlistLifecycle';
import {
    scopeSecurityOperationEventDetail,
    WATCHLIST_CLIENT_PUBLICATION_REQUIRED_FIELD,
    WATCHLIST_REVISION_PROGRESS_EVENT,
} from './securityResolutionEvents';

// Approves one staged factor data re-check through the same call and attempt
// id wherever it is approved: "Use new factor data", a Settings vendor switch
// on the Dashboard, or AppBar elsewhere. Returns the update's lifecycle, or
// throws a coded error when the approval did not start.
export async function applyStagedContextRefresh(staged) {
    const revisionId = staged?.watchlist_revision_id;
    const response = await applyWatchlistContextRefreshRevision({
        revisionId,
        attemptId: `watchlist-context-apply:${revisionId}`,
        expectedWatchlistRevisionId: staged?.source_watchlist_revision_id,
    });
    if (!response || response.success === false) {
        throw Object.assign(new Error(response?.message || 'Could not update factor data.'), {
            statusCode: response?.status_code, code: response?.code,
        });
    }
    const lifecycle = normalizeWatchlistLifecycle(response);
    if (!['queued', 'running', 'succeeded'].includes(lifecycle.status)) {
        throw Object.assign(
            new Error('The factor update could not be started. Your current data is unchanged.'),
            { retryable: false },
        );
    }
    return lifecycle;
}

// Tells the Watchlist's status about the update an approval started. The
// update moves the Watchlist to new factor data even when its securities stay
// the same, which the server publishes as no_change. So the app shell's
// publication coordinator publishes it like any other Watchlist change: the
// Dashboard reloads its risk data and advances its Watchlist version, and
// everything keyed on that version, the saved Optimizer portfolios included,
// reloads.
export function announceContextRefreshApproval(lifecycle, sessionScopeToken) {
    const detail = scopeSecurityOperationEventDetail({
        ...lifecycle,
        reason: 'watchlist_context_refresh_apply',
        [WATCHLIST_CLIENT_PUBLICATION_REQUIRED_FIELD]: true,
    }, sessionScopeToken);
    if (detail) window.dispatchEvent(new CustomEvent(WATCHLIST_REVISION_PROGRESS_EVENT, { detail }));
}
